import { GADimension } from '@ps/web-core-enums';

import { type ButtonClick, buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

export const searchClicked = (
  context: TrackingContextValue,
  { search, ...data }: ButtonClick & { search: string }
) => {
  GAEvent({ action: 'Button Pressed', label: data.buttonName }, context, {
    [GADimension.InputValue]: search
  });

  buttonClick(data, context);
};
